import React, { useEffect, useState } from 'react';
import ReactExport from 'react-data-export';
import { ButtonPrimary } from '@skf/bt-wind-rail-commonlibrary';
import { useTranslation } from 'react-i18next';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

interface ITurbineManagementDeleteProps {
  data: any;
  columns: any;
  onClick: () => void;
}

export const TurbineManagmentExcell: React.FunctionComponent<ITurbineManagementDeleteProps> = ({
  data,
  columns,
  onClick,
}) => {
  const { t } = useTranslation();
  const [dataToDownload, setDataToDownload] = useState([]);
  const multiDataSet = [
    {
      columns,
      data,
    },
  ];

  useEffect(() => {
    setDataToDownload(data);
  }, [data]);

  useEffect(() => {
    if (dataToDownload) {
      setTimeout(() => {
        setDataToDownload([]);
      }, 3000);
    }
  }, [dataToDownload]);

  return (
    <>
      <ButtonPrimary onClick={onClick}>{t('Download_Selected')}</ButtonPrimary>
      {dataToDownload.length > 0 && (
        <ExcelFile
          filename={'Turbine Management'}
          element={<ButtonPrimary>{t('Download_Selected')}</ButtonPrimary>}
          hideElement={true}
        >
          <ExcelSheet dataSet={multiDataSet} name="Organization" />
        </ExcelFile>
      )}
    </>
  );
};
